import { Box, Stack, Skeleton, Card, CardContent } from "@mui/material";

const KeywordTableSkeleton = () => {
  return (
    <Box sx={{ p: 0.8 }}>
      {/* Top Filter Row */}
      <Stack
        direction="row"
        justifyContent="space-between"
        alignItems="center"
        mb={2}
      ></Stack>

      {/* Performance Title */}
      <Skeleton variant="text" width={120} height={32} sx={{ mb: 2 }} />

      {/* Search / Filter Bar */}
      <Skeleton variant="rounded" width="100%" height={48} sx={{ mb: 3 }} />

      {/* Card Skeleton (Repeatable Component) */}
      {[1, 2, 3].map((item) => (
        <Card
          key={item}
          sx={{
            mb: 2,
            borderRadius: 2,
            maxHeight: 140,
          }}
        >
          <CardContent>
            <Stack spacing={2}>
              {/* Title Row */}
              <Stack direction="row" justifyContent="space-between">
                <Skeleton variant="text" width={180} height={24} />
                <Skeleton variant="circular" width={20} height={20} />
              </Stack>

              {/* Registration Text */}
              <Skeleton variant="text" width="70%" height={28} />

              {/* Metrics Row */}
              <Stack direction="row" spacing={3} alignItems="center">
                <Stack direction="row" spacing={1} alignItems="center">
                  <Skeleton variant="text" width={40} height={24} />
                  <Skeleton variant="rounded" width={40} height={24} />
                </Stack>

                <Stack direction="row" spacing={1} alignItems="center">
                  <Skeleton variant="text" width={50} height={24} />
                  <Skeleton variant="rounded" width={40} height={24} />
                </Stack>

                <Stack direction="row" spacing={1} alignItems="center">
                  <Skeleton variant="text" width={40} height={24} />
                </Stack>
              </Stack>
            </Stack>
          </CardContent>
        </Card>
      ))}
    </Box>
  );
};

export default KeywordTableSkeleton;
